module.exports = __webpack_public_path__ + "static/media/et.919059a4.svg";